/* @flow */

/**
 * External dependencies
 */
import { includes } from 'lodash';

/**
 * Internal dependencies
 */
import {
	INBOXES_SET_INBOX,
	INBOXES_SET_THREAD,
	INCREMENT_PROGRESS,
} from '../constants/action-types';

/**
 * Flow
 */
import type {
	InboxesSetInboxAction,
	InboxesSetThreadAction,
} from '../actions/inboxes';

type InboxesReset = {
	type: typeof INCREMENT_PROGRESS;
};

type InboxesReducerActions =
	InboxesReset |
	InboxesSetInboxAction |
	InboxesSetThreadAction;

export type InboxesState = {|
	inbox: null | number,
	read: Array<number>,
	thread: null | number,
|};

/**
 * Initial state
 */
export const initialState = {
	inbox: null,
	read: [],
	thread: null,
};

/**
 * Reducer
 */
export default function inboxes( state: InboxesState = initialState, action: InboxesReducerActions ) : InboxesState {
	switch ( action.type ) {
		case INCREMENT_PROGRESS:
			return initialState;

		case INBOXES_SET_INBOX:
			const read = [ ...state.read ];

			if ( null !== action.payload && ! includes( read, action.payload ) ) {
				read.push( action.payload );
			}

			return {
				...state,
				inbox: action.payload,
				read,
			};

		case INBOXES_SET_THREAD:
			return {
				...state,
				thread: action.payload,
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/inboxes.js